import { render } from "./entry_point.vue?vue&type=template&id=49e5cdcc"
import script from "./entry_point.vue?vue&type=script&lang=js"
export * from "./entry_point.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__